import AssetsManager from '../../../data/AssetsManager'
import MathUtil from '../../../util/MathUtil'

/**
 * WallViewクラス
 */
class WallView extends PIXI.Container {
  // ---------------------------------------------------------------------------------------------------------
  // --	WallView
  // ---------------------------------------------------------------------------------------------------------

  /**
   * コンストラクタ
   */
  constructor(w, h) {
    super()

    // console.log('WallView:' + w + ' - ' + h)

    //変数保持
    this.w = w
    this.h = h

    //コンフィグ
    this.config = AssetsManager.getConfig()

    //左の壁用コンテナ
    this.leftWallContainer = new PIXI.Container()
    this.addChild(this.leftWallContainer)

    //左の壁
    this.leftWall = new PIXI.Graphics()
    this.leftWall.beginFill(0xfe050b)
    this.leftWall.drawRect(-w/2 - this.config.STAGE_WIDTH, 0, this.config.STAGE_WIDTH - 6, h)
    this.leftWall.endFill()
    this.leftWallContainer.addChild(this.leftWall)

    //左の線
    this.leftLine = new PIXI.Graphics()
    this.leftLine.beginFill(0xfe050b)
    this.leftLine.drawRect(-w/2 - 8, 6, 8, h - 12)
    this.leftLine.endFill()
    this.leftWallContainer.addChild(this.leftLine)

    //右上のコーナー
    const cornerRT = AssetsManager.createSprite("corner.png")
    cornerRT.scale.set(2.5, 2.5)
    cornerRT.rotation = MathUtil.degreeToRadian(90)
    cornerRT.x = -w/2
    cornerRT.y = 0
    this.leftWallContainer.addChild(cornerRT)

    //右下のコーナー
    const cornerRB = AssetsManager.createSprite("corner.png")
    cornerRB.scale.set(2.5, 2.5)
    cornerRB.rotation = MathUtil.degreeToRadian(180)
    cornerRB.x = -w/2
    cornerRB.y = h
    this.leftWallContainer.addChild(cornerRB)

    //左の壁用コンテナ
    this.rightWallContainer = new PIXI.Container()
    this.addChild(this.rightWallContainer)

    //右の壁
    this.rightWall = new PIXI.Graphics()
    this.rightWall.beginFill(0xfe050b)
    this.rightWall.drawRect(w/2 + 6, 0, this.config.STAGE_WIDTH - 6, h)
    this.rightWall.endFill()
    this.rightWallContainer.addChild(this.rightWall)

    //右の線
    this.rightLine = new PIXI.Graphics()
    this.rightLine.beginFill(0xfe050b)
    this.rightLine.drawRect(w/2, 6, 8, h - 12)
    this.rightLine.endFill()
    this.rightWallContainer.addChild(this.rightLine)

    //左上のコーナー
    const cornerLT = AssetsManager.createSprite("corner.png")
    cornerLT.scale.set(2.5, 2.5)
    cornerLT.rotation = MathUtil.degreeToRadian(0)
    cornerLT.x = w/2
    cornerLT.y = 0
    this.rightWallContainer.addChild(cornerLT)

    //左下のコーナー
    const cornerLB = AssetsManager.createSprite("corner.png")
    cornerLB.scale.set(2.5, 2.5)
    cornerLB.rotation = MathUtil.degreeToRadian(-90)
    cornerLB.x = w/2
    cornerLB.y = h
    this.rightWallContainer.addChild(cornerLB)
  }

  // ---------------------------------------------------------------------------------------------------------
  // --	プレイヤーとの当たり判定
  // ---------------------------------------------------------------------------------------------------------

  hitTestPlayer(player)
  {
    const pb = player.ha.getBounds()
    const leftBounds = this.leftWallContainer.getBounds()
    const rightBounds = this.rightWallContainer.getBounds()

    return (
      leftBounds.contains(pb.x, pb.y) ||
      leftBounds.contains(pb.x + pb.width, pb.y) ||
      leftBounds.contains(pb.x + pb.width, pb.y + pb.height) ||
      leftBounds.contains(pb.x, pb.y + pb.height) ||
      rightBounds.contains(pb.x, pb.y) ||
      rightBounds.contains(pb.x + pb.width, pb.y) ||
      rightBounds.contains(pb.x + pb.width, pb.y + pb.height) ||
      rightBounds.contains(pb.x, pb.y + pb.height)
    )
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default WallView
